import { render, staticRenderFns } from "./Token.pc.vue?vue&type=template&id=2bab0d7e&scoped=true&"
import script from "./Token.pc.vue?vue&type=script&lang=js&"
export * from "./Token.pc.vue?vue&type=script&lang=js&"
import style0 from "./Token.pc.vue?vue&type=style&index=0&id=2bab0d7e&lang=scss&scoped=true&"
import style1 from "./Token.pc.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bab0d7e",
  null
  
)

export default component.exports